import { AxiosResponse } from "axios";
import API from "../api";
import { StorageBox, StorageBoxDto } from "../models/storage.box";
import BaseService from "./_base.service";
import { Options } from "./_base";
import { AllowArrayInCompanyId } from "../util/allowArrayInCompanyId";

const endpoint = "storage-boxes";

const StorageBoxService = {
  ...BaseService<AllowArrayInCompanyId<StorageBox>, StorageBox>({ endpoint }),

  async create(data: StorageBoxDto): Promise<AxiosResponse<StorageBox>> {
    return await API.post(`${endpoint}`, data);
  },

  async update(id: number, data: StorageBoxDto): Promise<AxiosResponse<boolean>> {
    return await API.put(`${endpoint}/${id}`, data);
  },

  async createList(data: StorageBoxDto[]): Promise<AxiosResponse<StorageBox[]>> {
    return await API.post(`${endpoint}/list`, data);
  },

  async getAllUnits(
    options?: Options<StorageBox>
  ): Promise<AxiosResponse<{ rows: StorageBox[]; count: number }>> {
    return await API.get(`${endpoint}/units`, { params: options });
  },

  async getDefaultList(params?: Options<StorageBox>): Promise<AxiosResponse<StorageBox[]>> {
    return await API.get(`${endpoint}/list`, { params });
  }
};

export default StorageBoxService;
